import type { CourseType } from 'bundles/enterprise-legacy-learner-home/utils/courseTypeMetadataUtils';

export type CourseTypeMetadata = {
  courseTypeMetadata: {
    __typename: string;
  };
};

export function isGuidedProject(courseTypeMetadata: CourseTypeMetadata | null | undefined) {
  return (
    courseTypeMetadata?.courseTypeMetadata.__typename === 'Course_RhymeProjectMetadata' ||
    courseTypeMetadata?.courseTypeMetadata.__typename === 'CourseTypeMetadataV1_rhymeProjectMember'
  );
}

export function isProject(courseTypeMetadata: CourseTypeMetadata | null | undefined) {
  return (
    courseTypeMetadata?.courseTypeMetadata.__typename === 'Course_ProjectMetadata' ||
    courseTypeMetadata?.courseTypeMetadata.__typename === 'CourseTypeMetadataV1_projectMember'
  );
}

export function isProjectOrSelfPacedProject(courseTypeMetadata: CourseTypeMetadata | null | undefined) {
  return isGuidedProject(courseTypeMetadata) || isProject(courseTypeMetadata);
}

export const getCourseType = (courseTypeMetadata: CourseTypeMetadata | null | undefined): CourseType | undefined => {
  switch (courseTypeMetadata?.courseTypeMetadata.__typename) {
    case 'Course_RhymeProjectMetadata':
    case 'CourseTypeMetadataV1_rhymeProjectMember':
      return 'GuidedProject';
    case 'Course_ProjectMetadata':
    case 'CourseTypeMetadataV1_projectMember':
      return 'Project';
    case 'Course_StandardCourseMetadata':
    case 'CourseTypeMetadataV1_standardCourseMember':
      return 'StandardCourse';
    case 'Course_VerifiedSkillsCourseMetadata':
    case 'CourseTypeMetadataV1_verifiedSkillsCourseMember':
      return 'VerifiedSkillsCourse';
    case 'Course_ShortFormContentMetadata':
    case 'CourseTypeMetadataV1_shortFormContentMember':
      return 'Assessment';
    default:
      throw new Error(`typeName of ${courseTypeMetadata?.courseTypeMetadata.__typename} not supported.`);
  }
};
